import { PreventScroll, ShouldPreventScroll } from '@/v2/components/utils/DeviceUtils';

const PlatformController = () => {
    if (ShouldPreventScroll()) {
        PreventScroll();
    }
};

export default PlatformController;
